import { css } from 'styled-components'

export const ScrollBarStyles = css`
   &::-webkit-scrollbar-track {
    border-radius: 0 4px 4px 0;
  	border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  	background-color: ${props => props.theme.colors.shades.neutral[1]};
  }

  &::-webkit-scrollbar {
  	width: 4px;
    height: 4px;
    border-radius: 0 4px 4px 0;
  	background-color: ${props => props.theme.colors.shades.neutral[1]};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
  	background-color: ${props => props.theme.colors.main.dark};
  }
`
